"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var SkillService = /** @class */ (function () {
    function SkillService(http) {
        this.http = http;
    }
    SkillService.prototype.makeSkillAvailable = function () {
        parent.postMessage('uwfSkillAvailable', '*');
    };
    SkillService.prototype.getSkillAvailabilityCheckSeconds = function () {
        return this.http.get('/api/floatingchat/getskillavailabilitycheckseconds');
    };
    SkillService.prototype.getDefaultSkillAddress = function () {
        return this.http.get('/api/floatingchat/getdefaultskilladdress');
    };
    SkillService.prototype.getSkillStatus = function (skillAddresses) {
        // do not use HttpParams because of the following defect where Angular fails to encode the plus sign
        // https://github.com/angular/angular/issues/11058
        return this.http.get('/api/floatingchat/checkskillstatus?addresses=' + encodeURIComponent(skillAddresses.join(',')), {
            responseType: 'json'
        });
    };
    SkillService.prototype.hideChatButton = function () {
        parent.postMessage('uwfHideChatButton', '*');
    };
    return SkillService;
}());
exports.SkillService = SkillService;
